// extracted by mini-css-extract-plugin
module.exports = {"base":"base--O1Kgl1","error":"error--gUyR1S"};